import { render } from "./Accordions.vue?vue&type=template&id=b2318460"
import script from "./Accordions.vue?vue&type=script&lang=js"
export * from "./Accordions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__